export function useWhite(color: string)
{
    let useWhite = false;
    let grey     = '#666666';
    let white    = '#ffffff';

    let ratioGrey  = getRatio(grey, color);
    let ratioWhite = getRatio(white, color);

    if (isSufficient(ratioWhite))
    {
        useWhite = true;
    }
    else if(ratioGrey < ratioWhite)
    {
        useWhite = true;
    }

    return useWhite;
}

export function checkContrast(foregroundHex: string, backgroundHex: string, tolerable: number = 0)
{
    let ratio = getRatio(foregroundHex, backgroundHex);

    return isSufficient(ratio, tolerable);
}

function isSufficient(ratio: number, tolerable: number = 0)
{
    return ratio >= (tolerable ? tolerable : 4.5);
}

function getColor(hex: string)
{
    hex = hex.replace('#', '');

    return hex;
}

function getL(color: string)
{
    let update = false;
    let R,
        G,
        B;

    if (color.length == 3)
    {
        update = true;
        R      = getsRGB(color.substring(0, 1) + color.substring(0, 1));
        G      = getsRGB(color.substring(1, 2) + color.substring(1, 2));
        B      = getsRGB(color.substring(2, 3) + color.substring(2, 3));
    }
    else if (color.length == 6)
    {
        update = true;
        R      = getsRGB(color.substring(0, 2));
        G      = getsRGB(color.substring(2, 4));
        B      = getsRGB(color.substring(4, 6));
    }

    if (update)
    {
        return (0.2126 * (R as number) + 0.7152 * (G as number) + 0.0722 * (B as number));
    }

    return false;
}

function getsRGB(color: string)
{
    let rgb = getRGB(color);
    if (rgb !== false)
    {
        rgb /= 255;
        rgb = (rgb <= 0.03928) ? rgb / 12.92 : Math.pow(((rgb + 0.055) / 1.055), 2.4);
        return rgb;
    }
    else
    {
        return false;
    }
}

export function getHex(rgb: string, alpha: boolean = false)
{
    const parts = rgb.match(/(\d{1,3}),\s?(\d{1,3}),\s?(\d{1,3}),?\s?([^,\s)]+)?/i);

    if(!parts)
    {
        // no rgb
        return false;
    }

    let r = parseInt(parts[1].trim()).toString(16);
    r = 1 === r.length ? '0' + r : r;

    let g = parseInt(parts[2].trim()).toString(16);
    g = 1 === g.length ? '0' + g : g;

    let b = parseInt(parts[3].trim()).toString(16);
    b = 1 === b.length ? '0' + b : b;

    let a = '';
    if(alpha && parts[4])
    {
        a = ((parseFloat(parts[4]) * 255) | 1 << 8).toString(16).slice(1);
        a = 1 === a.length ? '0' + a : a;
    }

    return '#' + r + g + b + a;
}

function getRGB(color: string)
{
    try
    {
        return parseInt(color, 16);
    }
    catch (err)
    {
        return false;
    }
}

function getRatio(foregroundHex: string, backgroundHex: string)
{
    let foregroundL = getL(getColor(foregroundHex));
    let backgroundL = getL(getColor(backgroundHex));

    if ('number' === typeof foregroundL && 'number' === typeof backgroundL)
    {
        return (Math.max(foregroundL, backgroundL) + 0.05) / (Math.min(foregroundL, backgroundL) + 0.05);
    }

    return 0;
}
